import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import { CRUSH_PROFILE_TYPE } from 'type-defs'
import ProfileHead from 'components/profile/ProfileHead'
import CrushCard from 'components/cards/CrushCard'
import MatchActions from 'components/actions/MatchActions'
import CrushActions from 'components/actions/CrushActions'

/** View for the logged-in user. */
const CrushProfile = props => {
  const {
    isMatch,
    firstName,
    distance,
    age,
    pictures,
    onFacebook,
    onMessenger,
    onLike,
    onDislike,
    onReportClick
  } = props

  return (
    <Div height="100%" display="flex" flexDirection="column">
      <Div
        display="flex"
        flex="0 0 17.5%"
        alignItems="center"
        paddingTop={15}
        paddingBottom={15}
        boxSizing="border-box"
      >
        <ProfileHead
          firstName={firstName}
          distance={distance}
          age={age}
          profilePic={pictures[0].url}
          onActionClick={onReportClick}
        />
      </Div>
      <Div display="flex" flex={1}>
        <CrushCard
          hideInfo
          firstName={firstName}
          age={age}
          distance={distance}
          pictures={pictures}
        />
      </Div>
      <Div
        display="flex"
        flex="0 0 15%"
        alignItems="center"
        justifyContent="center"
      >
        {isMatch ? (
          <MatchActions onFacebook={onFacebook} onMessenger={onMessenger} />
        ) : (
          <CrushActions onLike={onLike} onDislike={onDislike} />
        )}
      </Div>
    </Div>
  )
}

CrushProfile.propTypes = {
  ...CRUSH_PROFILE_TYPE,
  onLike: PropTypes.func,
  onDislike: PropTypes.func,
  onMessenger: PropTypes.func,
  onFacebook: PropTypes.func,
  onReportClick: PropTypes.func
}

CrushProfile.defaultProps = {
  onReportClick: () => {},
  onLike: () => {},
  onDislike: () => {},
  onMessenger: () => {},
  onFacebook: () => {}
}

export default CrushProfile



// WEBPACK FOOTER //
// ./src/components/profile/CrushProfile.js